/* eslint-disable import/no-anonymous-default-export */
export default {
  common: {
    keywordSearch: "Type Keyword to Search",
    noResults: "No results found.",
    actions: "Actions",
    add: "Add",
    edit: "Edit",
    view: "View",
    tag: "Tag",
    back: "Back",
    collapseMenu: "Collapse Menu",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    deleteConfirmMsg: "Are you sure you want to delete?",
    no: "No",
    yes: "Yes",
    noDataAvailable: "No Data Available",
    pagination: {
      rowsPerPage: "Rows per page:",
      range: "{{from}}–{{to}} of {{total}}",
      page: "Page",
      pageInput: "Page number",
      ofPages: "of {{total}}",
      firstPage: "First page",
      previousPage: "Previous page",
      nextPage: "Next page",
      lastPage: "Last page",
      invalidPage: "Enter a page from 1 to {{total}}",
    },
    reason: "Reason",
    createdBy: "Created By",
    modifiedBy: "Modified By",
    saveChanges: "Save Changes",
    close: "Close",
    pleaseEnter: "Please Enter...",
    globalSmartSearch: "Enter a Keyword to Search",
    loadingText: "We are loading the data for you. Please wait.",
    collapse: "Collapse",
    expand: "Expand",
    maximize: "Maximize",
    restore: "Restore",
    search: "Search",
    paracetamol: "paracetamol",
    clone: "Clone",
    disable: "Disable",
    enable: "Enable",
    manageWorkflow: "Manage Workflow",
    publish: "Publish",
    saveAsDocument: "Save As Document",
    preview: "Preview",
    download: "Download",
    summarizeIt: "Summarize It",
    translateDocument: "Translate Document",
    tenant: "Tenant",
    languageSwitch: "Language Switch",
    ac: "Admin Center",
    logout: "Logout",
    revert: "Revert",
    list: "List",
    showDeletedRecords: "Show Deleted Records",
    recordID: "Record ID",
    recordName: "Record Name",
    description: "Description",
    status: "Status",
    information: "Information",
    createdDate: "Created Date",
    modifiedDate: "Modified Date",
    basicInformation: "Basic Information",
    details: "Details",
    level: "Level",
    update: "Update",
    lock: "Lock",
    unlock: "Unlock",
    typeofAssociation: "Type of Association",
    recordDeleteTip:
      "Record <b>cannot be deleted </b> because it has the below dependencies.",
    recordStatusTip:
      "Status <b>cannot be changed </b> because it has the below dependencies.",
    comments: "Comments",
    clear: "Clear",
    apply: "Apply",
    clearFilter: "Clear Filters",
    downloadPDF: "Download as PDF",
    downloadCSV: "Download as CSV",
    downloadExcel: "Download as Excel",
    tokenIsExpired: "Your token is expired, please login again",
    tip: {
      addSuccess: "Add successfully.",
      addFailed: "Add failed.",
      updateSuccess: "Update successfully.",
      updateFailed: "Update failed.",
      revertSuccess: "Revert successfully.",
      revertFailed: "Revert failed.",
      deleteSuccess: "Delete successfully.",
      deleteFailed: "Delete failed.",
      deletion: "Please enter a reason for deletion.",
      limit_2000: "The input exceeds the maximum limit of 2,000 characters.",
      selectOneItem: "Please select one item.",
      selectTarget: "Please select target first.",
    },
    createdDateAndTime: "Created Date and Time",
    modifiedDateAndTime: "Modified Date and Time",
    audit: "Audit",
    deleteSelected: "Delete Selected",
    next: "Next",
    submit: "Submit",
    importInfo: "Import info",
    importTips: "Note: Supported File Formats .xls, .xlsx",
    downloadTemplate: "Download Template",
    unsavedChange: {
      title: "Unsaved changes",
      content: "Are you sure you want to leave this page? Any unsaved changes will be lost."
    },
    importFile: {
      tips: {
        noFileChoose: "Please choose a file or click cancel to exit this screen.",
        fileFormatError: "File type is not allowed.",
        fileDuplicate: "Please check and remove duplicate files.",
        importingData: "We are importing your data. Please wait for a few seconds.",
        importSuccess: "File imported successfully.",
        uploadSuccess: "The file has been uploaded successfully.",
        importFailure: "Failure Count",
        moreThanOne: "You cannot attach more than 1 files"
      }
    },
    businessRule: {
      title: "Setup Business Rules",
      source: 'Source',
      name: 'Name',
      field: 'Field',
      rule: 'Rule',
      values: 'Values',
      required: '{{fieldName}} is required',
      exists: 'Exists',
      equals: 'Equals',
      in: 'In'
    }
  },
  validation: {
    isRequired: "is required"
  },
  commonFilter: {
    filters: "Filters",
    filterby: "Filter by",
    select: "Select",
    search: "Search",
    clearFilters: "Clear Filters"
  },
  menu: {
    searchModule: "Search Module",
    modules: "Modules",
    uam: "UAM",
    users: "Users",
    roles: "Roles",
    userGroups: "User Groups",
    accessControl: "Access Control",
    cm: "Config. Manager",
    menuManager: "Menu Manager",
    formManager: "Form Manager",
    gridManager: "Grid Manager",
    audit: "Audit Reports",
    notifications: "Notifications",
    templates: "Templates",
    payloads: "Payloads",
    tasks: "Tasks",
    history: "History",
    importACL: "Import Access Control",
    importUser: "Import User",
    importGroup: "Import User Group",
    importRole: "Import Role",
    workflowManager: "Workflow Manager",
    knowledgeManager: "Knowledge Manager",
  },
  notification: {
    domainName: "Domain Name",
    moduleName: "Module Name",
    fieldName: "Field Name",
    templateId: "Template Id",
    templateName: "Template Name",
    createdDate: "Created Date",
    createdDateAndTime: "Created Date and Time",

    payloads: "Payloads",
    payloadId: "Payload ID",
    notificationPayload: "Notification Payload",
    remarks: "Remarks",
    status: "Status",

    tasks: "Tasks",
    taskId: "Task ID",
    taskType: "Task Type",
    scheduledDate: "Past Scheduled Date and Time",
    lastScheduledDate: "Upcoming Scheduled Date and Time",
    endDate: "End Date and Time",

    history: "History",
    notificationContent: "Notification Content",
    receiver: "Receiver",

    Templates: "Templates",
    cancelTask: "Cancel Task",
    tips: {
      copiedSuccess: "Copied successfully",
      cancelSucess: "Task canceled successfully",
      cancelConfirm: 'The selected task shall be <b class="alert-text">Cancel</b>. <br /> Do you wish to proceed?',
    },

    basic: {
      tab: "Template Configuration",
      title: "List of templates to create notification",
      addTemplate: "Add Template",
      editTemplate: "Edit Template",
      viewTemplate: "View Template",
      templatedescription: "Template description",
      notificationType: "Notification Type",
      notificationFrequency: "Notification Frequency",
      notificationChannels: "Notification Channels",
      condition: "Condition",
      interval: "Interval",
      intervalUnit: "Interval Unit",
      frequency: "Occurrence",
      notificationDisabled: "Template Inactivate",
      frequencyNeedsCondition: "A Frequency template of this module can be activated once it has at least one condition.",
      isBundled: "Is Bundled",
      deleteTemplate: "Delete Template",
      tips: {
        deleteSuccess: "Template deleted successfully",
        deleteOne: "Please select the data you want to delete",
        deleteConfirm: 'The selected template shall be <b class="alert-text">Deleted</b>. <br /> Do you wish to proceed?',
        updatedSuccess: "Template updated successfully",
        addSuccess: "Template added successfully"
      },
      recurringPattern: {
        title: "Recurring Pattern",
        description: "Define when and how often this notification should run.",
        recurrenceLabel: "Recurrence:",
        firstSendLabel: "First scheduled send:",
        notApplicable: "Not applicable.",
        recurringType: "Recurring Type",
        occurrencePlaceholder: "please select Occurence from 1 to 100 only",
        intervalPlaceholder: "1-100",
        unitPlaceholder: "Unit",
        frequencyType: "Frequency Type",
        frequencyTypePlaceholder: "please select Frequency Type",
        startDate: "Start Date",
        endDate: "End Date",
        sendTime: "Email Send Time",
        timeZone: "Time Zone",
        sendTimeHint:
          "The email may not go out at this exact time. A short delay can happen while the system prepares and sends it.",
        everyWeeks: "Every (week(s))",
        on: "On",
        end: "End",
        occurrences: "occurrences",
        repeatFrequency: "Repeat Frequency",
        day: "Day",
        ofEvery: "of every",
        months: "month(s)",
        the: "The",
        ok: "OK",
        continue: "Continue",
        shortMonthTitle: "Some months have fewer than {{day}} days.",
        shortMonthBody: "In those months the notification will fallback to send on the last valid day of the month.",
        noValidSendTitle: "Warning",
        noValidSendBody: "The configured frequency yields no valid send dates within the selected Start and End Date range.",
        types: {
          occurrence: "Occurrence",
          frequency: "Frequency",
        },
        frequencyTypes: {
          weekly: "Weekly",
          monthly: "Monthly",
        },
        ordinals: {
          first: "First",
          second: "Second",
          third: "Third",
          fourth: "Fourth",
          last: "Last",
        },
        weekdays: {
          day: "Day",
          monday: "Monday",
          tuesday: "Tuesday",
          wednesday: "Wednesday",
          thursday: "Thursday",
          friday: "Friday",
          saturday: "Saturday",
          sunday: "Sunday",
        },
        weekdayShort: {
          sunday: "S",
          monday: "M",
          tuesday: "T",
          wednesday: "W",
          thursday: "T",
          friday: "F",
          saturday: "S",
        },
        endTypes: {
          onDate: "On this day",
          afterOccurrences: "After",
          never: "Never",
        },
        units: {
          2: "Days",
          3: "Weeks",
          4: "Months",
          5: "Years",
        },
      },
    },
    conditions: {
      tab: "Conditions",
      addCondition: "Add Condition",
      conditionField: "Condition Field",
      selectField: "Please select \"Group / Form / Field\"",
      operator: "Operator",
      rule: "Rule",
      value: "Value",
      form: "Form",
      group: "Group",
      andLogicInfo: "Email notifications will only be sent when ALL conditions are met (AND relationship)",
      groupBy: {
        title: "Group By",
        empty: "Not configured. Click to set it up.",
        configured: "Configured: {{summary}}",
        mark: "Mark As Group By",
        limit: "Up to {{max}} fields. Each change is saved at once.",
        saveFailed: "Failed to update Group By",
        foreignBlocked: "Group By uses only fields of this template's module. Delete these conditions first: {{conditions}}",
        foreignVariablesBlocked: "Group By uses only fields of this template's module. Remove these variables from the content first: {{variables}}",
        occurrenceConfirmTitle: "Switch to Occurrence",
        occurrenceConfirmContent: "This template has Group By fields. Group By only applies to Frequency, so it will be kept but not used. Continue?",
      },
      regulation: {
        title: "Regulation Condition",
        empty: "No regulation condition selected",
        summary: "Marked field changes will be included in the email trigger event.",
        editAriaLabel: "Edit regulation condition",
        editorDescription: "Select one or more categories. Marked field changes will be included in the email trigger event.",
        clear: "Clear",
        options: {
          IDMPC: "IDMP Conditional Field",
          xEVMPDC: "xEVMPD Conditional Field",
          UDIC: "UDI Conditional Field",
          IDMPO: "IDMP Optional Field",
          xEVMPDO: "xEVMPD Optional Field",
          UDIO: "UDI Optional Field",
          IDMPM: "IDMP Mandatory Field",
          xEVMPDM: "xEVMPD Mandatory Field",
          UDIM: "UDI Mandatory Field",
          SUBC: "Submission Conditional Field",
          SUBO: "Submission Optional Field",
          SUBM: "Submission Mandatory Field",
        },
      },
      tips: {
        addAtAime: "Only one new line can be added at a time",
        addSuccess: "Condition added successfully",
        updatedSuccess: "Condition updated successfully",
        deleteSuccess: "Condition deleted successfully",
        missingData: "Missing required data. Please complete Basic and Content tabs first.",
        regulationUpdated: "Regulation condition updated successfully",
        regulationUpdateFailed: "Failed to update regulation condition",
      }
    },
    exitConfirm: {
      title: "Unsaved Changes",
      message: "You have unsaved changes. Are you sure you want to exit? All data will be lost.",
      confirm: "Exit Without Saving",
    },
    content: {
      tab: "Template Content",
      subjectTitle: "Subject Title",
      templateTitle: "Template Title",
      templateContent: "Template Content",
      to: "To",
      cc: "CC",
      bcc: "BCC",
      enterEmailAddresses: "Enter email addresses (separate by space, comma or enter)",
      email: "Email",
      fields: "Fields",
      tips: {
        updatedSuccess: "Template content updated successfully",
      }
    },
    bundle: {
      tab: "Bundle Configuration",
      bundleField: "Bundle Field",
      bundleName: "Bundle Name",
      addBundle: "Add Bundle",
      tips: {
        addAtAime: "Only one new line can be added at a time",
        addSuccess: "Bundle added successfully",
        updatedSuccess: "Bundle updated successfully",
        deleteSuccess: "Bundle deleted successfully",
      }
    }
  },
};
